import React, { useState, useEffect } from 'react';

interface Slide {
    title: string;
    subtitle: string;
    cta: string;
    event: string;
}

const slides: Slide[] = [
    {
        title: 'Slimme Software, Sneller Resultaat.',
        subtitle: 'Wij zetten jouw doelen om in efficiënte code. Geen eindeloze projecten, wel concrete groei. Snel, slim en altijd gericht op jouw succes.',
        cta: 'Start de Sprint',
        event: 'hero_slide_1'
    },
    {
        title: 'Jouw Ambities, Vertaald in Code.',
        subtitle: 'We bouwen wat je nodig hebt: van snelle apps tot slimme automatisering. Duidelijke taal, scherpe code en een focus op jouw unieke uitdaging.',
        cta: 'Zet de Eerste Stap',
        event: 'hero_slide_2'
    },
    {
        title: 'Software die Werkt. Groei die Telt.',
        subtitle: 'Wij leveren high-performance software die je bedrijf vooruithelpt. Geen onnodige complexiteit, wel meetbaar resultaat dat je direct in je business voelt.',
        cta: 'Ontdek de Mogelijkheden',
        event: 'hero_slide_3'
    }
];

interface HeroSliderProps {
    scrollTo: (id: string) => void;
}

export const HeroSlider: React.FC<HeroSliderProps> = ({ scrollTo }) => {
    const [index, setIndex] = useState(0);

    useEffect(() => {
        const id = setInterval(() => setIndex(i => (i + 1) % slides.length), 6000);
        return () => clearInterval(id);
    }, []);

    const labels = ['Apps', 'Systemen', 'Automatisering', 'Optimalisatie'];

    return (
        <div className="text-center select-none">
            {/* Chip with blue dot separators */}
            <div className="inline-flex items-center bg-white/80 backdrop-blur-sm border border-gray-200 rounded-full px-5 py-1.5 text-xs sm:text-sm text-gray-600 mb-6 tracking-wide space-x-2">
                {labels.map((l, i) => (
                    <React.Fragment key={l}>
                        {i > 0 && <span className="inline-block w-1.5 h-1.5 rounded-full bg-[#3d68ff]" aria-hidden="true" />}
                        <span>{l}</span>
                    </React.Fragment>
                ))}
            </div>
            {/* Slider track */}
            <div className="overflow-hidden relative">
                <div className="flex transition-transform duration-700 ease-out" style={{ transform: `translateX(-${index * 100}%)` }} aria-live="polite">
                    {slides.map((s, i) => (
                        <div key={s.title} className="w-full flex-shrink-0 px-2">
                            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[#0A2540] tracking-tight max-w-5xl mx-auto leading-tight">
                                {(() => {
                                    const normalized = s.title.replace(/,/g, '.');
                                    const parts = normalized.split(/(\.)/);
                                    return parts.map((p, idx) => {
                                        if (p === '.') {
                                            return <span key={idx} className="text-[#3d68ff] inline-block align-baseline px-2">●</span>;
                                        }
                                        const text = p.trim();
                                        if (!text) return null;
                                        const next = parts[idx + 1];
                                        return <React.Fragment key={idx}>{text}{(next && next !== '.') ? ' ' : ''}</React.Fragment>;
                                    });
                                })()}
                            </h1>
                            <p className="max-w-2xl mx-auto mt-6 text-lg text-gray-600">{s.subtitle}</p>
                            <div className="mt-8">
                                <button onClick={() => { scrollTo('contact'); }} className="bg-[#3315e8] text-white font-semibold rounded-[21px] px-8 py-3 hover:opacity-90 transition-opacity">
                                    {s.cta}
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className="flex justify-center space-x-2 mt-4" aria-label="Hero slider navigatie">
                {slides.map((_, i) => (
                    <button
                        key={i}
                        onClick={() => { setIndex(i); }}
                        className={`w-2.5 h-2.5 rounded-full transition-all ${i === index ? 'bg-[#3315e8]' : 'bg-[#3315e8]/15 hover:bg-[#3315e8]/30'}`}
                    >
                        <span className="sr-only">Slide {i + 1}</span>
                    </button>
                ))}
            </div>
        </div>
    );
};
